module.exports = __webpack_public_path__ + "img/close.a81ca328.svg";